import api from './api';

export interface DeliveryTimes {
  CLIP: number;
  COMPLETE_GLASSES: number;
}

export const getDeliveryTimes = async (): Promise<DeliveryTimes> => {
  const response = await api.get<DeliveryTimes>('/admin/delivery-times');
  return response.data;
};

export const updateDeliveryTimes = async (times: DeliveryTimes): Promise<DeliveryTimes> => {
  const response = await api.put<DeliveryTimes>('/admin/delivery-times', times);
  return response.data;
};

export interface GlassOption {
  id: string;
  name: string;
  description?: string | null;
  active: boolean;
  createdAt: string;
}

export interface BandOption {
  id: string;
  name: string;
  description?: string | null;
  active: boolean;
  createdAt: string;
}

export const getAllGlassOptions = async (): Promise<GlassOption[]> => {
  const response = await api.get<GlassOption[]>('/admin/glass-options');
  return response.data;
};

export const createGlassOption = async (data: {
  name: string;
  description?: string;
  active?: boolean;
}): Promise<GlassOption> => {
  const response = await api.post<GlassOption>('/admin/glass-options', data);
  return response.data;
};

export const updateGlassOption = async (
  id: string,
  data: { name: string; description?: string; active?: boolean }
): Promise<GlassOption> => {
  const response = await api.put<GlassOption>(`/admin/glass-options/${id}`, data);
  return response.data;
};

export const deleteGlassOption = async (id: string): Promise<void> => {
  await api.delete(`/admin/glass-options/${id}`);
};

export const getAllBandOptions = async (): Promise<BandOption[]> => {
  const response = await api.get<BandOption[]>('/admin/band-options');
  return response.data;
};

export const createBandOption = async (data: {
  name: string;
  description?: string;
  active?: boolean;
}): Promise<BandOption> => {
  const response = await api.post<BandOption>('/admin/band-options', data);
  return response.data;
};

export const updateBandOption = async (
  id: string,
  data: { name: string; description?: string; active?: boolean }
): Promise<BandOption> => {
  const response = await api.put<BandOption>(`/admin/band-options/${id}`, data);
  return response.data;
};

export const deleteBandOption = async (id: string): Promise<void> => {
  await api.delete(`/admin/band-options/${id}`);
};

export interface GoggleModel {
  id: string;
  name: string;
  description?: string | null;
  active: boolean;
  createdAt: string;
  glassOptions?: Array<{
    id: string;
    active: boolean;
    glassOption: GlassOption;
  }>;
  bandOptions?: Array<{
    id: string;
    active: boolean;
    bandOption: BandOption;
  }>;
  productTypes?: Array<{
    id: string;
    productType: 'CLIP' | 'COMPLETE_GLASSES';
    active: boolean;
  }>;
}

export const getAllGoggleModels = async (): Promise<GoggleModel[]> => {
  const response = await api.get<GoggleModel[]>('/admin/goggle-models');
  return response.data;
};

export const getGoggleModelById = async (id: string): Promise<GoggleModel> => {
  const response = await api.get<GoggleModel>(`/admin/goggle-models/${id}`);
  return response.data;
};

export const createGoggleModel = async (data: {
  name: string;
  description?: string;
  active?: boolean;
}): Promise<GoggleModel> => {
  const response = await api.post<GoggleModel>('/admin/goggle-models', data);
  return response.data;
};

export const updateGoggleModel = async (
  id: string,
  data: { name: string; description?: string; active?: boolean }
): Promise<GoggleModel> => {
  const response = await api.put<GoggleModel>(`/admin/goggle-models/${id}`, data);
  return response.data;
};

export const deleteGoggleModel = async (id: string): Promise<void> => {
  await api.delete(`/admin/goggle-models/${id}`);
};

export const updateModelGlassOptions = async (
  modelId: string,
  glassOptionIds: string[]
): Promise<GoggleModel> => {
  const response = await api.put<GoggleModel>(`/admin/goggle-models/${modelId}/glass-options`, {
    glassOptionIds,
  });
  return response.data;
};

export const updateModelBandOptions = async (
  modelId: string,
  bandOptionIds: string[]
): Promise<GoggleModel> => {
  const response = await api.put<GoggleModel>(`/admin/goggle-models/${modelId}/band-options`, {
    bandOptionIds,
  });
  return response.data;
};

export const updateModelProductTypes = async (
  modelId: string,
  productTypes: ('CLIP' | 'COMPLETE_GLASSES')[]
): Promise<GoggleModel> => {
  const response = await api.put<GoggleModel>(`/admin/goggle-models/${modelId}/product-types`, {
    productTypes,
  });
  return response.data;
};